export function throw_expression(message: string = ""): never {
    throw new Error(message);
}